import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ShieldCheck, MessageSquare, Lock } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-emerald-950 text-emerald-50 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2 md:col-span-1">
          <Logo onDark />
          <p className="text-sm text-emerald-200/80 mt-4 leading-relaxed">
            Doğru Usta, Doğru İş, Güvenli İletişim. İşinizi güvenle yaptırın.
          </p>
        </div>
        <div>
          <h4 className="font-bold mb-3 text-sm">Keşfet</h4>
          <ul className="space-y-2 text-sm text-emerald-200/80">
            <li><Link to="/ilanlar" className="hover:text-white">İş İlanları</Link></li>
            <li><Link to="/ustalar" className="hover:text-white">Ustalar</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            <li><Link to="/ilan-ver" className="hover:text-white">İlan Ver</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold mb-3 text-sm">Kurumsal</h4>
          <ul className="space-y-2 text-sm text-emerald-200/80">
            <li><Link to="/hakkimizda" className="hover:text-white">Hakkımızda</Link></li>
            <li><Link to="/nasil-calisir" className="hover:text-white">Nasıl Çalışır?</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold mb-3 text-sm">Güvence</h4>
          <ul className="space-y-3 text-sm text-emerald-200/80">
            <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4" /> Güvenli Platform</li>
            <li className="flex items-center gap-2"><MessageSquare className="h-4 w-4" /> Dahili Mesajlaşma</li>
            <li className="flex items-center gap-2"><Lock className="h-4 w-4" /> Gizli İletişim</li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold mb-3 text-sm">Yasal</h4>
          <ul className="space-y-2 text-sm text-emerald-200/80">
            <li><Link to="/mesafeli-satis-sozlesmesi" className="hover:text-white">Mesafeli Satış Sözleşmesi</Link></li>
            <li><Link to="/teslimat-ve-iade" className="hover:text-white">Teslimat ve İade Şartları</Link></li>
            <li><Link to="/gizlilik-sozlesmesi" className="hover:text-white">Gizlilik Sözleşmesi (KVKK)</Link></li>
            <li><Link to="/hakkimizda" className="hover:text-white">Hakkımızda</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-emerald-800/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-emerald-300/70">
          <span>© 2026 Ustayla.com — Tüm hakları saklıdır.</span>
          <span className="flex items-center gap-2"><Lock className="h-3.5 w-3.5" /> 256-Bit SSL ile güvenli ödeme · iyzico altyapısı</span>
          <span>Ustayla, taraflar arasındaki hizmet bedelini tahsil etmez.</span>
        </div>
      </div>
    </footer>
  );
}
